import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type MaterialRangeTagItemFragment = { __typename: 'Tag', id: string, name: string, assignments: Array<{ __typename: 'TagAssignment', assignedTo?: { __typename: 'Asset' } | { __typename: 'Hdri' } | { __typename: 'Material', legacyId: number, name?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, latestCyclesRevision?: { __typename: 'MaterialRevision', legacyId: number } | null } | { __typename: 'Model' } | { __typename: 'Picture' } | { __typename: 'Project' } | { __typename: 'Set' } | { __typename: 'Template' } | null }> };

export type GetMaterialRangeTagsListQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TagFilterInput>;
  order?: Types.InputMaybe<Array<Types.TagOrderByInput> | Types.TagOrderByInput>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetMaterialRangeTagsListQuery = { __typename: 'Query', totalCount: number, items: Array<{ __typename: 'Tag', id: string, name: string, assignments: Array<{ __typename: 'TagAssignment', assignedTo?: { __typename: 'Asset' } | { __typename: 'Hdri' } | { __typename: 'Material', legacyId: number, name?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, latestCyclesRevision?: { __typename: 'MaterialRevision', legacyId: number } | null } | { __typename: 'Model' } | { __typename: 'Picture' } | { __typename: 'Project' } | { __typename: 'Set' } | { __typename: 'Template' } | null }> } | null> };

export const MaterialRangeTagItemFragmentDoc = gql`
    fragment MaterialRangeTagItem on Tag {
  id
  name
  assignments {
    assignedTo {
      ... on Material {
        legacyId
        name
        galleryImage {
          id
        }
        latestCyclesRevision {
          legacyId
        }
      }
    }
  }
}
    `;
export const GetMaterialRangeTagsListDocument = gql`
    query getMaterialRangeTagsList($filter: TagFilterInput, $order: [TagOrderByInput!], $skip: Int, $take: Int) {
  items: tags(filter: $filter, orderBy: $order, skip: $skip, take: $take) {
    ...MaterialRangeTagItem
  }
  totalCount: tagsCount(filter: $filter)
}
    ${MaterialRangeTagItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaterialRangeTagsListGQL extends Apollo.Query<GetMaterialRangeTagsListQuery, GetMaterialRangeTagsListQueryVariables> {
    override document = GetMaterialRangeTagsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }